export enum InvestmentLevel {
  NATIONAL = 'National',
  INTERNATIONAL = 'International',
}
